module.exports = __webpack_public_path__ + "assets/img/icon9-menu2.7b836670.svg";